<template>
    <v-card>
        <v-card-title
        class="grey lighten-2 title"
        primary-title
        >   
            <div v-if="$router.currentRoute.path == '/nuevavisita'">Nueva Visita</div>            
            <div v-if="$router.currentRoute.path == '/editarvisita'">Editar Visita</div>
        </v-card-title>
        <v-card-text>
            
        </v-card-text>
        
        <v-container grid-list-md>
            <v-layout wrap>
                <v-flex xs12>
                    <v-text-field v-model="notaVisita" label="Descripción" type="text"></v-text-field>
                </v-flex>
                <v-flex xs3>
                    <v-checkbox
                    v-model="clientePotencial"
                    label="Cliente Potencial"
                    color="primary"
                    hide-details
                    ></v-checkbox>
                </v-flex>
                <v-flex xs8 v-if="$router.currentRoute.path == '/editarvisita'">
                    <v-dialog
                        ref="dialog"
                        v-model="modal"
                        :return-value.sync="date"
                        persistent
                        width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="dateFormatted"
                            label="Fecha de Visita"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="date"
                            scrollable
                            locale="es-es"
                            >
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                color="primary"
                                @click="modal = false"
                            >
                                Cancel
                            </v-btn>
                            <v-btn
                                text
                                color="primary"
                                @click="$refs.dialog.save(date)"
                            >
                                OK
                            </v-btn>
                        </v-date-picker>
                    </v-dialog>
                </v-flex>
                <!--v-flex xs12 v-if="!clientePotencial">
                    <v-text-field v-model="custFilter" label="Cliente" type="text" required></v-text-field>
                </v-flex-->
                <v-flex xs12 v-if="!clientePotencial">
                    <v-container
                    id="scroll-target"
                    style="max-height: 200px"
                    class="scroll-y"
                    fluid
                    pa-0>
                        <listaClientes/>
                    </v-container>
                </v-flex>
                <v-flex xs12 v-if="clientePotencial">
                    <v-text-field v-model="nombreCP" label="Nombre Cliente" type="text" required :disabled = !clientePotencial></v-text-field>
                </v-flex>
                <v-flex xs3 offset-xs2>
                    <v-text-field
                    label="Desde:"
                    v-model="start"
                    value="12:00:00"
                    type="text"
                    inputmode="numeric"
                    @change="validateStart"
                    @focus="onSelectHourInputStart"
                    @blur="onBlurHourInputStart"
                    autocomplete="off"
                    ></v-text-field>
                    <!--v-col style="flex: 0 1 auto;">
                        <h2>Desde:</h2>
                        <v-time-picker
                        v-model="start"
                        :max="end"
                        format="24hr"
                        @change="validateStart"
                        ></v-time-picker>
                    </v-col-->
                </v-flex>
                <v-flex xs3 offset-xs2>
                    <v-text-field
                    label="Hasta:"
                    v-model="end"
                    value="12:30:00"
                    type="text"
                    inputmode="numeric"
                    @change="validateEnd"
                    @focus="onSelectHourInputEnd"
                    @blur="onBlurHourInputEnd"
                    autocomplete="off"
                    ></v-text-field>
                    <!--v-col style="flex: 0 1 auto;">
                        <h2>Hasta:</h2>
                        <v-time-picker
                        v-model="end"
                        :min="start"
                        format="24hr"
                        @change="validateEnd"
                        ></v-time-picker>
                    </v-col-->
                </v-flex>
                <!--v-flex xs12>
                    <v-text-field maxlength="80" v-model="comentario" label="Comentario" type="text" :rules="lenRule"></v-text-field>
                </v-flex-->
                <v-badge 
                    v-model="show"
                    overlap
                    >
                    <template v-slot:badge>
                        <span>{{commentsLength()}}</span>
                    </template>
                    <v-btn
                        color="primary"
                        flat
                        @click="gotoComments()"
                    >
                        Comentarios 
                    </v-btn>
                </v-badge>
            </v-layout>
        </v-container>

        <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="error"
            flat
            @click="closeDialog()"
        >
            Cancelar
        </v-btn>
        <v-btn                
            color="success"
            flat                
            @click="closeOKDialog()"
            :loading="loading_"
            :disabled="!$store.state.customer && !potentialCustomer"
        >
            Confirmar
        </v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
    import listaClientes from '@/components/listaClientes_new.vue'
    import commentList from '@/components/commentList.vue'
    export default {
        name: 'cardCreateTodo',
        data () {
          return {             
            timeout: null,
            alert: false,
            alertContent: '',
            validFrom: false,
            validTo: false,
            show: false
            /*lenRule: [ 
                v => ( v && v.length < 80) || "Longitud máxima 80 caracteres",
            ],*/
          }
        },
        methods:{                
            closeDialog(){           
                this.dialogCreateTodo = false;
                this.$router.push('rutas');
            },
            closeOKDialog(){  
                this.dialogCreateTodo = false;
                if (this.dialogCreateTodoData.editEvent)
                    this.actualizarVisita(this.clientePotencial,this.nombreCP);
                else
                    this.crearVisita(this.clientePotencial,this.nombreCP);
                this.$router.push('rutas');
            },
            commentsLength(){
                if (this.comentarios.length){
                    if ((this.comentarios.length == 1) && (this.comentarios[0].comment == '')) {
                        this.show = false;
                        return 0;
                    } else {
                        this.show = true;
                        return this.comentarios.length;
                    }
                } else {
                    this.show = false;
                    return 0;
                }
            },
            gotoComments(){
                this.$store.state.visitaComentarios = true;
            },
            getCust(){
                let auxthis = this;
                //Para prevenir que cierren el dialog con un cliente elegido y se cambie cuando acabe una busqueda pendiendte,
                //desde que se cambie el filtro no permitiremos cerrar la page hasta que acabe la busqueda
                this.loading_ = true; 
                this.timeout = setTimeout(function () {
                    auxthis.getCustomers();               
                    //console.log('test');
                }, 1500);
            },
            onSelectHourInputStart(){
                if (this.start == '--:--'){
                    this.start = '';
                }
            },
            onBlurHourInputStart(){
                if (this.start == ''){
                    this.start = '--:--';
                }
            },
            onSelectHourInputEnd(){
                if (this.end == '--:--'){
                    this.end = '';
                }
            },
            onBlurHourInputEnd(){
                if (this.end == ''){
                    this.end = '--:--';
                }
            },
            validateStart(){    
                var thisaux = this;
                let regex = /^([0-1]?[0-9]|2[0-3])[0-5][0-9]$/g;
                let regex_ = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/g;
                var a = regex.test(this.start);
                var b = regex_.test(this.start);
                if (this.start != ''){
                    //Comprobamos si la hora esta correcta (con o sin punto)
                    var result_reg = a || b;
                    if (!result_reg){
                        this.start = '';
                        this.alertinfoContent = 'Introduzca una hora válida';
                        this.alertinfo = true;
                        setTimeout(function(){
                            thisaux.alertinfo = false;
                            thisaux.alertinfoContent = ''
                        },3000);
                        return;
                    } else {
                        //Correcto
                        //Si no tiene punto...
                        if (!b){
                            this.start = this.start.substring(0,this.start.length-2) + ':' + this.start.substring(this.start.length-2);
                        }
                    }
                } else {
                    return;
                }            
            },
            validateEnd(){
                var thisaux = this;
                let regex = /^([0-1]?[0-9]|2[0-3])[0-5][0-9]$/g;
                let regex_ = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/g;
                var a = regex.test(this.end);
                var b = regex_.test(this.end);
                if (this.end != ''){
                    var result_reg = a || b;
                    if (!result_reg){
                        this.end = '';
                        this.alertinfoContent = 'Introduzca una hora válida';
                        this.alertinfo = true;
                        setTimeout(function(){
                            thisaux.alertinfo = false;
                            thisaux.alertinfoContent = ''
                        },3000);
                        return;
                    } else {
                        //Correcto
                        //Si no tiene punto...
                        if (!b){
                            this.end = this.end.substring(0,this.end.length-2) + ':' + this.end.substring(this.end.length-2);
                        }
                    }
                } else {
                    return;
                }
            },
            formatDate (date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            },
            parseDate (date) {
                if (!date) return null

                const [day, month, year] = date.split('/')
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            },
            computedDateFormatted () {
                return this.formatDate(this.date)
            },
        },
        watch:{
            /*custFilter: function(val, oldVal){
                this.getCust();
            },*/
            custIndex: function(val, oldVal){
                console.log(val);
                this.nombreCP = this.$store.state.customers[val].name;
            },
            date (val) {
                this.dateFormatted = this.formatDate(this.date)
            },
        },
        computed: {  
            custIndex:{
                get(){
                    return this.$store.state.selectedCustIndex;
                },
            },
            notaVisita: {
                get(){
                    return this.$store.state.dialogCreateTodoData.notaVisita;
                },
                set(value){
                    this.$store.commit('setNotaVisita',value);
                }
            },
            comentarios: {
                get(){
                    return this.$store.state.dialogCreateTodoData.comentarios;
                }
            },
            custFilter:{
                get(){
                    return this.$store.state.custFilter;
                },
                set(value){
                    this.$store.commit('setCustFilter',value);
                }
            },   
            loading_:{
              get(){
                    return this.$store.state.activeAxiosComms.customer;
                },
              set(value){
                  this.$store.commit('setCustomerLoading',value);
              } 
            },
            dialogCreateTodo:{
                get(){
                    return this.$store.state.dialogCreateTodo;
                },
                set(value){
                    this.$store.state.dialogCreateTodo = value;
                }
            },
            dialogCreateTodoData:{
                get(){
                    return this.$store.state.dialogCreateTodoData;
                }
            },
            start: {
                get(){
                    return this.$store.state.dialogCreateTodoData.start;
                },
                set(value){                
                    this.$store.commit('setHourStart',value);
                }
            },
            end:{
                get(){
                    return this.$store.state.dialogCreateTodoData.end;
                },
                set(value){                
                    this.$store.commit('setHourEnd',value);
                }
            },
            clientePotencial:{
                get(){
                    return this.$store.state.clientePotencial;
                },
                set(value){                
                    this.$store.commit('setClientePotencial',value);
                }
            },
            nombreCP:{
                get(){
                    return this.$store.state.nombreCP;
                },
                set(value){                
                    this.$store.commit('setNombreCP',value);
                }
            },
            modal:{
                get(){
                    return this.$store.state.visitaPickerDialog;
                },
                set(value){                
                    this.$store.state.visitaPickerDialog = value;
                }
            },
            date:{
                get(){
                    return this.$store.state.visitaDate;
                },
                set(value){                
                    this.$store.commit('setVisitaDate',value);
                }
            },
            dateFormatted:{
                get(){
                    return this.$store.state.visitaDateFormatted;
                },
                set(value){                
                    this.$store.commit('setVisitaDateFormatted',value);
                }
            }
        },
        components: {
            listaClientes,
            commentList
        }
    }
    </script>